// ReservationFailureModal.tsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

interface ReservationFailureModalProps {
  open: boolean;
  onClose: () => void;
}

export const ReservationFailureModal: React.FC<ReservationFailureModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="reservation-failure-modal-title"
      aria-describedby="reservation-failure-modal-description"
    >
      <DialogTitle id="reservation-failure-modal-title">予約受付失敗</DialogTitle>
      <DialogContent>
        <Typography id="reservation-failure-modal-description" color="text.secondary" sx={{ lineHeight: 1.9 }}>
          予約受付処理中に問題が発生しました。入力内容を確認し、もう一度お試しください。
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
};
